import { useDateFormatter } from "@/hooks/useDateFormatter";
import { estimateReason } from "../estimate-reasons";
import {
  ContractFamilyCategory,
  ContractFamilyExpiry,
  SummaryText,
} from "@/views/suppliers/components/contract-family-enrichment";
import type { SpendFamilySummary } from "@/types/spend";

interface Props {
  family: SpendFamilySummary;
}

export const FamilySummaryDetails = ({ family }: Props) => {
  const { formatDate } = useDateFormatter();
  return (
    <dl
      aria-label={`${family.name} contract summary`}
      className="grid gap-x-8 gap-y-3 px-5 py-4 text-sm sm:grid-cols-[auto_auto_auto_minmax(0,1fr)]"
    >
      {family.reasons?.length ? (
        <div className="sm:col-span-4" role="status">
          <dt className="font-semibold">
            Estimate unavailable
            {family.estimate_valuation_date ? ` on ${formatDate(family.estimate_valuation_date)}` : ""}
          </dt>
          <dd>
            {family.reasons.map(reason => (
              <p key={reason}>{estimateReason(reason)}</p>
            ))}
          </dd>
        </div>
      ) : null}
      <div>
        <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">Status</dt>
        <dd className="mt-1 font-semibold capitalize text-[#111b35]">{family.procurement_status || "Not set"}</dd>
      </div>
      <div className="min-w-0">
        <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">Category</dt>
        <dd className="mt-1">
          <ContractFamilyCategory category={family.category} />
        </dd>
      </div>
      <div>
        <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">Expiry</dt>
        <dd className="mt-1">
          <ContractFamilyExpiry expiryDate={family.expiry_date} status={family.procurement_status} />
        </dd>
      </div>
      {family.price_escalation ? (
        <div className="min-w-0">
          <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">Price escalation</dt>
          <dd className="mt-1 text-gray-700">
            <SummaryText text={family.price_escalation} />
          </dd>
        </div>
      ) : null}
    </dl>
  );
};
